const common = {
  siteName: 'Erdemir Elektrik',
  siteTagline: 'Pano Otomasyon İnşaat San. ve Tic. A.Ş.',
  nav: {
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    activities: 'Faaliyetlerimiz',
    applications: 'Uygulamalarımız',
    references: 'Referanslarımız',
    partners: 'Çözüm Ortaklarımız',
    contact: 'İletişim',
  },
  footer: {
    cta: 'Birlikte Çalışalım',
    corporate: 'Kurumsal',
    social: 'Sosyal Medya',
    newsletter: 'Bülten',
    newsletterText: 'Gelişmelerden haberdar olmak için bültenimize abone olun.',
    copyright: '© 2024 Erdemir Elektrik. Tüm hakları saklıdır.',
  },
  hero: {
    subtitle: '500+ Kurumsal Projenin Çözüm Ortağı',
    title1: 'Güç İletiminde',
    title2: 'Güvenilir Çözüm Ortağınız',
    description: '1983\'ten bu yana kalite, süreklilik ve müşteri memnuniyeti ile sektörde hizmet veriyoruz.',
    cta: 'Projelerimizi İnceleyin',
  },
  home: {
    activitiesTitle: 'Faaliyet',
    activitiesTitleHighlight: 'Alanlarımız',
    activitiesSubtitle: 'Elektrik ve otomasyon sektöründe sunduğumuz kapsamlı hizmetler',
    activitiesLabel: 'Elektrik & Otomasyon',
    partnersTitle: 'Çözüm Ortaklarımız',
    partnersSubtitle: 'Tedarik ettiğimiz dünya devi markalarla güçlüyüz',
    partnersCta: 'Tüm Ortaklarımız',
    stats: {
      experience: 'Yıllık Sektör Deneyimi',
      projects: 'Tamamlanan Proje',
    },
  },
  about: {
    title: 'Hakkımızda',
    subtitle: '1983\'ten beri elektrik sektöründe',
  },
  activities: {
    title: 'Faaliyetlerimiz',
    subtitle: 'Elektrik ve elektronik sektörüne yönelik geniş ürün gruplarında hizmet',
  },
  applications: {
    title: 'Uygulamalarımız',
    subtitle: 'Endüstriyel ve kurumsal elektrik çözümleri',
  },
  references: {
    title: 'Referanslarımız',
    subtitle: 'Güvenilir iş ortaklıklarımızla tamamladığımız projeler',
    label: 'Güvenilir İş Ortaklıkları',
  },
  partners: {
    title: 'Çözüm Ortaklarımız',
    subtitle: 'Tedarik ettiğimiz dünya devi markalarla güçlüyüz',
  },
  contact: {
    title: 'İletişim',
    subtitle: 'Bizimle iletişime geçin',
    address: 'Adres',
    phone: 'Telefon',
    email: 'E-posta',
    formTitle: 'Bize Ulaşın',
    formName: 'Adınız Soyadınız',
    formEmail: 'E-posta Adresiniz',
    formPhone: 'Telefon Numaranız',
    formSubject: 'Konu',
    formMessage: 'Mesajınız',
    formSubmit: 'Gönder',
    formSuccess: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
    support247: 'Teknik Destek',
    established: 'Kuruluş',
  },
};

export default common;